import React, { useContext } from 'react'
import styles from './TextButtonBanner.module.css';

const TextButtonBanner = (props) => {
	const title = props.title;
	const text = props.text;
	const button_text = props.button_text;
	const button_link = props.button_link;
	const cropImage = props.cropImage;
	return (
		<div className={styles.layout}>

			<div className={styles.left}>

				<div className={styles.text}>
					<span className={styles.title}><b>{title}</b></span>
					<br/>
					<br/>
					<p>
						{text}
					</p>
				</div>

				<div className={styles.button_row}>
					<a 
						data_tealium_category="link"
						data_tealium_action="click pdf_link"
						data_tealium_type="download"
						data_tealium_value= {`${button_text}|${button_link}`}
						href={button_link}
						target="_blank" rel="noopener noreferrer"
					>
					{button_text}
					</a>
				</div>

			</div>

			<div className={styles.right}>
				<div style={{backgroundImage:`url(${cropImage})`}} role="img" src="a weed seedling growing in a field" className={styles.picture} />
			</div>

			<div className={styles.mobile_button_row}>
				<a 
					data_tealium_category="link"
					data_tealium_action="click pdf_link"
					data_tealium_type="download"
					data_tealium_value= {`${button_text}|${button_link}`}
					href={button_link}
					target="_blank" rel="noopener noreferrer"
				>
					{button_text}
				</a>
			</div>

		</div>
	);
}


export default TextButtonBanner;